(function ($) {

	function init_property_goals() {
		$(".property-goals__show-more").off("click").on("click", function (e) {
			$(this).closest(".property-goals").addClass('property-goals--show-more');
		})
	}

	$(document).gp_ready(init_property_goals)

})(jQuery);